import { apiCallV2 } from "../../../utils/api";
import { } from "./types";
import { sha1 } from "locutus/php/strings"

export const CallImpactConversion = (irclickid, token, email) => async () => {

   const res = await apiCallV2(
      "POST",
      "create-impact-conversion",
      {
         irclickid: irclickid,
      },
      token,
   );

   if (res.status == 200) {

      window.callConversion(
         process.env.REACT_APP_IMPACT_ACCOUNT_CREATION,
         res.data.data.conversion_oid,
         res.data.data.user_id + "",
         sha1(email.trim(" "))
      );
   }

}

export const CallPlanStart = (orderDetails, user) => async (getState) => {

   const irclickid = localStorage.getItem("irclickid");

   if (irclickid) {

      const res = await apiCallV2(
         "GET",
         "get-impact-data",
         "",
         localStorage.getItem("access-token"),
      );

      const impactData = res.data.data[0];

      window.callPlanStart(
         process.env.REACT_APP_IMPACT_ACCOUNT_SUBSCRIPTION,
         impactData.conversion_oid,
         orderDetails,
         impactData.user_id + "",
         sha1(user.email_address.trim(" ")),
      );

   }
};